import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import type { DTOBulkInviteResponse } from 'src/apis/dto/DTOInviteFromSwipeAzar';
import { RESTClient } from 'src/apis/service';
import { InviteFromSwipeAzarService } from 'src/apis/service/InviteFromSwipeAzarService';

type UseBulkInviteOptions = Omit<
  UseMutationOptions<DTOBulkInviteResponse, Error, string[]>,
  'mutationFn'
>;

export const useBulkInvite = (options?: UseBulkInviteOptions) =>
  useMutation({
    mutationFn: (cardIds: string[]) =>
      new InviteFromSwipeAzarService(new RESTClient()).bulkInvite({ cardIds }),
    ...options,
  });
